import React, { useState, useEffect, useContext } from "react";
// import Backdrop from '@mui/material/Backdrop';
// import Box from '@mui/material/Box';
// import Modal from '@mui/material/Modal';
// import Fade from '@mui/material/Fade';
import Slider from "react-slick";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import '../ModalPopup/ModalPopup.css'
import URLstateContext from "../../provider/CommonContext";
import { Vortex } from 'react-loader-spinner'
import animation from '../../images/jm-animation.gif';




import {
    GetMethodData,
    DecryptAESdata,
} from "../../provider/ServiceProvider";
import { Modal } from "react-bootstrap";
import Close from '../../images/popup_close-btn.png'
function ModalPopup() {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [Fetchdata, getData] = useState("");
    const { BaseURL } = useContext(URLstateContext);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [loadingshow, setloadingshow] = useState(false);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 470,
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
    };
    const settings = {
        dots: false,
        className: 'sample',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true
                },
            },
        ]
    };

    useEffect(() => {
        setloadingshow(true);
        GetMethodData(BaseURL + "GetPopupBanner").then((data) => {
            if (data.data != null && data.data.length > 0) {
                getData(DecryptAESdata(data.data));
                setOpen(true)
                setloadingshow(false);
                // console.log(DecryptAESdata(data.data))
            }
            else {
                setOpen(false)
                setloadingshow(false);
            }
        });
    }, [BaseURL]);
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClosepop = () => {
        setOpen(false);
    };
    return (
        <>
            <div className="Modal-Popup">
                <Dialog
                    fullScreen={fullScreen}
                    open={open}
                    onClose={handleClosepop}
                    aria-labelledby="responsive-dialog-title"
                    sx={{
                        m: 5,
                        fontSize: '0.875rem',
                        fontWeight: '700',
                    }}
                >
                    <DialogContent className="modal-content">
                    <DialogActions>  
                        <button className="btn-close-home" aria-label="popup close button">
                           <img src={Close}  onClick={handleClose} className="close-popup" alt="close-button"></img>
                           </button>
                    </DialogActions>
                    {Fetchdata && Fetchdata.length > 0 ? (
                        <Slider {...settings}>
                        {/* {(Fetchdata === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                            {Fetchdata &&
                                Fetchdata.map(({ imgfilename, caption, bannerlink, investlink }, index) => (
                                    <div className="w-100">
                                        <img
                                            alt={imgfilename}
                                          //  src={BaseURL.replace("api/", "") + imgfilename}
                                          src={imgfilename}
                                            className="img-fluid"
                                        />
                                    </div>
                                ))}
                                 {loadingshow ? <div className="textcentervertex">
                                {/* <Vortex
                                    visible={true}
                                    height="80"
                                    width="80"
                                    ariaLabel="vortex-loading"
                                    wrapperStyle={{}}
                                    wrapperClass="vortex-wrapper"
                                    colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                /> */}
                                 <img src={animation} alt="Loading" />
                                <div className="model_popup">Please Wait...</div>
                            </div> : ""
                            }
                        </Slider>
                         ) : (
                            <h5 className="errormsgComNew">No Data Found !!!</h5>
                          )}
                    </DialogContent>
                    {/* <DialogActions>  
                           <img src={Close}  onClick={handleClose} className="close-popup"></img>
                    </DialogActions> */}
                </Dialog>


                {/* <Modal open={open}
                    onClose={handleClosepop} className="modal company-snap-modal">
                    <Modal.Body id="modal_info">
                    <Slider {...settings}>
                            {Fetchdata &&
                                Fetchdata.map(({ imgfilename, caption, bannerlink, investlink }, index) => (
                                    <div>
                                        <img
                                            alt={imgfilename}
                                            src={BaseURL.replace("api/", "") + imgfilename}
                                            className="img-fluid"
                                        />
                                    </div>
                                ))}
                        </Slider>
                    </Modal.Body>
                  </Modal> */}
            </div>
        </>
    )
}

export default ModalPopup